import cacheLs from "../cacheLs"

export default {
  setSaasOrgData (state, data) {
    state.saasOrgData = data
    cacheLs.set_saasOrgData(data)
  }
}
